import Vue from 'vue';
import Croppa from 'df-croppa';

Vue.use(Croppa);
